module.exports = "/_next/static/files/2ff579061abde9ea6ff52480bad1aeb8.jpg";